import React from 'react';
interface Props {
  width?: number;
  color1?: string;
  color2?: string;
}
function IllustrationContactSvg(props: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      enableBackground="new 0 0 500 320"
      viewBox="0 0 500 320"
    >
      <g id="Calque_1"></g>
      <g id="Calque_2"></g>
      <g id="Calque_3"></g>
      <g id="Calque_4"></g>
      <g id="Calque_5"></g>
      <g id="Calque_6">
        <g id="XMLID_503_">
          <defs>
            <filter
              id="Adobe_OpacityMaskFilter"
              filterUnits="userSpaceOnUse"
              x="49.9"
              y="25.1"
              width="410.1"
              height="262.3"
            >
              <feColorMatrix type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0" />
            </filter>
          </defs>
          <mask maskUnits="userSpaceOnUse" x="49.9" y="25.1" width="410.1" height="262.3" id="fond_gradient_8_">
            <g id="XMLID_623_" className="st0">
              <linearGradient
                id="XMLID_650_"
                gradientUnits="userSpaceOnUse"
                x1="292.4158"
                y1="275.5493"
                x2="292.4158"
                y2="30.6739"
              >
                <stop offset="0" stopColor="#FFFFFF" />
                <stop offset="1" stopColor="#000000" />
              </linearGradient>
              <rect id="XMLID_626_" x="-71" y="38" className="st1" width="726.9" height="238.5" />
            </g>
          </mask>
          <g id="fond_gradient_5_" className="st2">
            <path
              id="XMLID_11753_"
              className="st3"
              d="M430.8,274.4c-26.4,19.5-288.4,15-360.2,0c-14.9-12.3-28.4-67.7-15.7-106.1
            c18.3-55.3,37.6-99.2,61.5-118.2c30.3-24,74.4-18,112,13c39.7,32.7,111.2-38.7,142-38c85,2,22.5,101.6,62.2,128.6
            C477,183.9,460.6,247.3,430.8,274.4z"
            />
          </g>
          <g id="XMLID_11366_">
            <polygon
              id="XMLID_11749_"
              className="st5"
              points="419.3,155.2 419.3,263.5 403.8,263.5 369.7,263.5 369.7,155.2 403.8,155.2 			"
            />
            <polygon
              id="XMLID_11748_"
              className="st5"
              points="155.4,168.1 171.8,168.1 171.8,167.3 171.8,160.5 171.8,159.5 171.8,152.7
            171.8,151.7 171.8,145.2 200,145.2 212.7,145.2 212.7,151.7 212.7,152.7 212.7,159.5 212.7,160.5 212.7,167.3 212.7,168.3
            212.7,175.1 212.7,176.1 212.7,182.9 212.7,183.9 212.7,190.7 212.7,191.7 212.7,198.5 212.7,199.5 212.7,206.3 212.7,207.3
            212.7,214.1 212.7,215.1 212.7,221.9 212.7,222.9 212.7,229.7 212.7,230.7 212.7,237.5 212.7,238.5 212.7,245.4 212.7,246.3
            212.7,253.2 212.7,254.1 212.7,263.5 200,263.5 173.8,263.5 171.8,263.5 155.4,263.5 114.7,263.5 114.7,168.1 			"
            />
            <polygon
              id="XMLID_11754_"
              className="st5"
              points="344.1,168.1 327.7,168.1 327.7,167.3 327.7,160.5 327.7,159.5 327.7,152.7
            327.7,151.7 327.7,145.2 299.5,145.2 286.7,145.2 286.7,151.7 286.7,152.7 286.7,159.5 286.7,160.5 286.7,167.3 286.7,168.3
            286.7,175.1 286.7,176.1 286.7,182.9 286.7,183.9 286.7,190.7 286.7,191.7 286.7,198.5 286.7,199.5 286.7,206.3 286.7,207.3
            286.7,214.1 286.7,215.1 286.7,221.9 286.7,222.9 286.7,229.7 286.7,230.7 286.7,237.5 286.7,238.5 286.7,245.4 286.7,246.3
            286.7,253.2 286.7,254.1 286.7,263.5 299.5,263.5 325.7,263.5 327.7,263.5 344.1,263.5 384.7,263.5 384.7,168.1 			"
            />
            <path
              id="XMLID_11747_"
              className="st5"
              d="M231.4,92.2c0-2.6,2.1-4.8,4.8-4.8h44.5c0,0,0.1,0,0.1,0c1.2,0,2.3,0.5,3.1,1.3
            c0.9,0.9,1.5,2.1,1.5,3.5v0.2v7.2h10.5v35h37.6h18.4v128.9h-18.4h-37.6h-3.1h-20.3h-51.7V99.6h10.5V92.2z"
            />
            <g id="XMLID_11574_">
              <rect id="XMLID_11746_" x="369.9" y="137.1" className="st5" width="57.2" height="124.9" />
              <rect id="XMLID_11745_" x="409.3" y="137.1" className="st5" width="17.8" height="124.9" />
              <g id="XMLID_11733_">
                <rect id="XMLID_11744_" x="373.6" y="143.1" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11743_" x="378.4" y="143.1" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11742_" x="383.2" y="143.1" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11741_" x="388" y="143.1" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11740_" x="392.8" y="143.1" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11739_" x="397.6" y="143.1" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11738_" x="402.4" y="143.1" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11737_" x="411.2" y="143.1" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11736_" x="416" y="143.1" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11735_" x="420.8" y="143.1" className="st6" width="2.6" height="3.6" />
              </g>
              <g id="XMLID_11722_">
                <rect id="XMLID_11732_" x="373.6" y="150.6" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11731_" x="378.4" y="150.6" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11730_" x="383.2" y="150.6" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11729_" x="388" y="150.6" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11728_" x="392.8" y="150.6" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11727_" x="397.6" y="150.6" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11726_" x="402.4" y="150.6" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11725_" x="411.2" y="150.6" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11724_" x="416" y="150.6" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11723_" x="420.8" y="150.6" className="st6" width="2.6" height="3.6" />
              </g>
              <g id="XMLID_11711_">
                <rect id="XMLID_11721_" x="373.6" y="158.1" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11720_" x="378.4" y="158.1" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11719_" x="383.2" y="158.1" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11718_" x="388" y="158.1" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11717_" x="392.8" y="158.1" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11716_" x="397.6" y="158.1" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11715_" x="402.4" y="158.1" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11714_" x="411.2" y="158.1" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11713_" x="416" y="158.1" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11712_" x="420.8" y="158.1" className="st6" width="2.6" height="3.6" />
              </g>
              <g id="XMLID_11700_">
                <rect id="XMLID_11710_" x="373.6" y="165.7" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11709_" x="378.4" y="165.7" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11708_" x="383.2" y="165.7" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11707_" x="388" y="165.7" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11706_" x="392.8" y="165.7" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11705_" x="397.6" y="165.7" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11704_" x="402.4" y="165.7" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11703_" x="411.2" y="165.7" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11702_" x="416" y="165.7" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11701_" x="420.8" y="165.7" className="st6" width="2.6" height="3.6" />
              </g>
              <g id="XMLID_11688_">
                <rect id="XMLID_11699_" x="373.6" y="173.2" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11698_" x="378.4" y="173.2" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11697_" x="383.2" y="173.2" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11696_" x="388" y="173.2" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11694_" x="392.8" y="173.2" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11693_" x="397.6" y="173.2" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11692_" x="402.4" y="173.2" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11691_" x="411.2" y="173.2" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11690_" x="416" y="173.2" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11689_" x="420.8" y="173.2" className="st6" width="2.6" height="3.6" />
              </g>
              <g id="XMLID_11677_">
                <rect id="XMLID_11687_" x="373.6" y="180.7" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11686_" x="378.4" y="180.7" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11685_" x="383.2" y="180.7" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11684_" x="388" y="180.7" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11683_" x="392.8" y="180.7" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11682_" x="397.6" y="180.7" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11681_" x="402.4" y="180.7" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11680_" x="411.2" y="180.7" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11679_" x="416" y="180.7" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11678_" x="420.8" y="180.7" className="st6" width="2.6" height="3.6" />
              </g>
              <g id="XMLID_11666_">
                <rect id="XMLID_11676_" x="373.6" y="188.3" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11675_" x="378.4" y="188.3" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11674_" x="383.2" y="188.3" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11673_" x="388" y="188.3" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11672_" x="392.8" y="188.3" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11671_" x="397.6" y="188.3" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11670_" x="402.4" y="188.3" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11669_" x="411.2" y="188.3" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11668_" x="416" y="188.3" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11667_" x="420.8" y="188.3" className="st6" width="2.6" height="3.6" />
              </g>
              <g id="XMLID_11654_">
                <rect id="XMLID_11665_" x="373.6" y="195.8" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11664_" x="378.4" y="195.8" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11663_" x="383.2" y="195.8" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11662_" x="388" y="195.8" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11661_" x="392.8" y="195.8" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11660_" x="397.6" y="195.8" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11659_" x="402.4" y="195.8" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11658_" x="411.2" y="195.8" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11657_" x="416" y="195.8" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11655_" x="420.8" y="195.8" className="st6" width="2.6" height="3.6" />
              </g>
              <g id="XMLID_11643_">
                <rect id="XMLID_11653_" x="373.6" y="203.3" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11652_" x="378.4" y="203.3" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11651_" x="383.2" y="203.3" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11650_" x="388" y="203.3" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11649_" x="392.8" y="203.3" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11648_" x="397.6" y="203.3" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11647_" x="402.4" y="203.3" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11646_" x="411.2" y="203.3" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11645_" x="416" y="203.3" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11644_" x="420.8" y="203.3" className="st6" width="2.6" height="3.6" />
              </g>
              <g id="XMLID_11632_">
                <rect id="XMLID_11642_" x="373.6" y="210.9" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11641_" x="378.4" y="210.9" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11640_" x="383.2" y="210.9" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11639_" x="388" y="210.9" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11638_" x="392.8" y="210.9" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11637_" x="397.6" y="210.9" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11636_" x="402.4" y="210.9" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11635_" x="411.2" y="210.9" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11634_" x="416" y="210.9" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11633_" x="420.8" y="210.9" className="st6" width="2.6" height="3.6" />
              </g>
              <g id="XMLID_11621_">
                <rect id="XMLID_11631_" x="373.6" y="218.4" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11630_" x="378.4" y="218.4" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11629_" x="383.2" y="218.4" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11628_" x="388" y="218.4" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11627_" x="392.8" y="218.4" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11626_" x="397.6" y="218.4" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11625_" x="402.4" y="218.4" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11624_" x="411.2" y="218.4" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11623_" x="416" y="218.4" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11622_" x="420.8" y="218.4" className="st6" width="2.6" height="3.6" />
              </g>
              <g id="XMLID_11609_">
                <rect id="XMLID_11620_" x="373.6" y="225.9" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11619_" x="378.4" y="225.9" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11618_" x="383.2" y="225.9" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11616_" x="388" y="225.9" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11615_" x="392.8" y="225.9" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11614_" x="397.6" y="225.9" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11613_" x="402.4" y="225.9" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11612_" x="411.2" y="225.9" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11611_" x="416" y="225.9" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11610_" x="420.8" y="225.9" className="st6" width="2.6" height="3.6" />
              </g>
              <g id="XMLID_11598_">
                <rect id="XMLID_11608_" x="373.6" y="233.4" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11607_" x="378.4" y="233.4" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11606_" x="383.2" y="233.4" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11605_" x="388" y="233.4" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11604_" x="392.8" y="233.4" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11603_" x="397.6" y="233.4" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11602_" x="402.4" y="233.4" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11601_" x="411.2" y="233.4" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11600_" x="416" y="233.4" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11599_" x="420.8" y="233.4" className="st6" width="2.6" height="3.6" />
              </g>
              <g id="XMLID_11587_">
                <rect id="XMLID_11597_" x="373.6" y="241" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11596_" x="378.4" y="241" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11595_" x="383.2" y="241" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11594_" x="388" y="241" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11593_" x="392.8" y="241" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11592_" x="397.6" y="241" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11591_" x="402.4" y="241" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11590_" x="411.2" y="241" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11589_" x="416" y="241" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11588_" x="420.8" y="241" className="st6" width="2.6" height="3.6" />
              </g>
              <g id="XMLID_11575_">
                <rect id="XMLID_11586_" x="373.6" y="248.5" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11585_" x="378.4" y="248.5" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11584_" x="383.2" y="248.5" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11583_" x="388" y="248.5" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11582_" x="392.8" y="248.5" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11581_" x="397.6" y="248.5" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11580_" x="402.4" y="248.5" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11579_" x="411.2" y="248.5" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11577_" x="416" y="248.5" className="st6" width="2.6" height="3.6" />
                <rect id="XMLID_11576_" x="420.8" y="248.5" className="st6" width="2.6" height="3.6" />
              </g>
            </g>
            <g id="XMLID_11543_">
              <rect id="XMLID_11573_" x="174.3" y="95.9" className="st5" width="44.3" height="127.8" />
              <rect id="XMLID_11572_" x="204.7" y="95.9" className="st5" width="13.8" height="127.8" />
              <g id="XMLID_11570_">
                <rect id="XMLID_11571_" x="174.3" y="102.9" className="st6" width="44.3" height="1.1" />
              </g>
              <g id="XMLID_11568_">
                <rect id="XMLID_11569_" x="174.3" y="111.3" className="st6" width="44.3" height="1.1" />
              </g>
              <g id="XMLID_11566_">
                <rect id="XMLID_11567_" x="174.3" y="119.7" className="st6" width="44.3" height="1.1" />
              </g>
              <g id="XMLID_11564_">
                <rect id="XMLID_11565_" x="174.3" y="128.2" className="st6" width="44.3" height="1.1" />
              </g>
              <g id="XMLID_11562_">
                <rect id="XMLID_11563_" x="174.3" y="136.6" className="st6" width="44.3" height="1.1" />
              </g>
              <g id="XMLID_11560_">
                <rect id="XMLID_11561_" x="174.3" y="145" className="st6" width="44.3" height="1.1" />
              </g>
              <g id="XMLID_11558_">
                <rect id="XMLID_11559_" x="174.3" y="153.5" className="st6" width="44.3" height="1.1" />
              </g>
              <g id="XMLID_11556_">
                <rect id="XMLID_11557_" x="174.3" y="161.9" className="st6" width="44.3" height="1.1" />
              </g>
              <g id="XMLID_11554_">
                <rect id="XMLID_11555_" x="174.3" y="170.3" className="st6" width="44.3" height="1.1" />
              </g>
              <g id="XMLID_11552_">
                <rect id="XMLID_11553_" x="174.3" y="178.8" className="st6" width="44.3" height="1.1" />
              </g>
              <g id="XMLID_11550_">
                <rect id="XMLID_11551_" x="174.3" y="187.2" className="st6" width="44.3" height="1.1" />
              </g>
              <g id="XMLID_11548_">
                <rect id="XMLID_11549_" x="174.3" y="195.6" className="st6" width="44.3" height="1.1" />
              </g>
              <g id="XMLID_11546_">
                <rect id="XMLID_11547_" x="174.3" y="204.1" className="st6" width="44.3" height="1.1" />
              </g>
              <g id="XMLID_11544_">
                <rect id="XMLID_11545_" x="174.3" y="212.5" className="st6" width="44.3" height="1.1" />
              </g>
            </g>
            <g id="XMLID_11367_">
              <g id="XMLID_11370_">
                <rect id="XMLID_11542_" x="84.1" y="45.5" className="st5" width="81.2" height="177.2" />
                <rect id="XMLID_11541_" x="140" y="45.5" className="st5" width="25.3" height="177.2" />
                <g id="XMLID_11529_">
                  <rect id="XMLID_11540_" x="89.3" y="54" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11538_" x="96.1" y="54" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11537_" x="103" y="54" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11536_" x="109.8" y="54" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11535_" x="116.6" y="54" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11534_" x="123.4" y="54" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11533_" x="130.2" y="54" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11532_" x="142.7" y="54" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11531_" x="149.5" y="54" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11530_" x="156.3" y="54" className="st6" width="3.7" height="5.1" />
                </g>
                <g id="XMLID_11518_">
                  <rect id="XMLID_11528_" x="89.3" y="64.7" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11527_" x="96.1" y="64.7" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11526_" x="103" y="64.7" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11525_" x="109.8" y="64.7" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11524_" x="116.6" y="64.7" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11523_" x="123.4" y="64.7" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11522_" x="130.2" y="64.7" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11521_" x="142.7" y="64.7" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11520_" x="149.5" y="64.7" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11519_" x="156.3" y="64.7" className="st6" width="3.7" height="5.1" />
                </g>
                <g id="XMLID_11507_">
                  <rect id="XMLID_11517_" x="89.3" y="75.3" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11516_" x="96.1" y="75.3" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11515_" x="103" y="75.3" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11514_" x="109.8" y="75.3" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11513_" x="116.6" y="75.3" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11512_" x="123.4" y="75.3" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11511_" x="130.2" y="75.3" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11510_" x="142.7" y="75.3" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11509_" x="149.5" y="75.3" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11508_" x="156.3" y="75.3" className="st6" width="3.7" height="5.1" />
                </g>
                <g id="XMLID_11495_">
                  <rect id="XMLID_11506_" x="89.3" y="86" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11505_" x="96.1" y="86" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11504_" x="103" y="86" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11503_" x="109.8" y="86" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11502_" x="116.6" y="86" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11501_" x="123.4" y="86" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11499_" x="130.2" y="86" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11498_" x="142.7" y="86" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11497_" x="149.5" y="86" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11496_" x="156.3" y="86" className="st6" width="3.7" height="5.1" />
                </g>
                <g id="XMLID_11484_">
                  <rect id="XMLID_11494_" x="89.3" y="96.7" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11493_" x="96.1" y="96.7" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11492_" x="103" y="96.7" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11491_" x="109.8" y="96.7" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11490_" x="116.6" y="96.7" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11489_" x="123.4" y="96.7" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11488_" x="130.2" y="96.7" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11487_" x="142.7" y="96.7" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11486_" x="149.5" y="96.7" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11485_" x="156.3" y="96.7" className="st6" width="3.7" height="5.1" />
                </g>
                <g id="XMLID_11473_">
                  <rect id="XMLID_11483_" x="89.3" y="107.4" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11482_" x="96.1" y="107.4" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11481_" x="103" y="107.4" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11480_" x="109.8" y="107.4" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11479_" x="116.6" y="107.4" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11478_" x="123.4" y="107.4" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11477_" x="130.2" y="107.4" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11476_" x="142.7" y="107.4" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11475_" x="149.5" y="107.4" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11474_" x="156.3" y="107.4" className="st6" width="3.7" height="5.1" />
                </g>
                <g id="XMLID_11462_">
                  <rect id="XMLID_11472_" x="89.3" y="118.1" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11471_" x="96.1" y="118.1" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11470_" x="103" y="118.1" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11469_" x="109.8" y="118.1" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11468_" x="116.6" y="118.1" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11467_" x="123.4" y="118.1" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11466_" x="130.2" y="118.1" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11465_" x="142.7" y="118.1" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11464_" x="149.5" y="118.1" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11463_" x="156.3" y="118.1" className="st6" width="3.7" height="5.1" />
                </g>
                <g id="XMLID_11450_">
                  <rect id="XMLID_11460_" x="89.3" y="128.7" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11459_" x="96.1" y="128.7" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11458_" x="103" y="128.7" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11457_" x="109.8" y="128.7" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11456_" x="116.6" y="128.7" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11455_" x="123.4" y="128.7" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11454_" x="130.2" y="128.7" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11453_" x="142.7" y="128.7" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11452_" x="149.5" y="128.7" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11451_" x="156.3" y="128.7" className="st6" width="3.7" height="5.1" />
                </g>
                <g id="XMLID_11439_">
                  <rect id="XMLID_11449_" x="89.3" y="139.4" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11448_" x="96.1" y="139.4" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11447_" x="103" y="139.4" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11446_" x="109.8" y="139.4" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11445_" x="116.6" y="139.4" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11444_" x="123.4" y="139.4" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11443_" x="130.2" y="139.4" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11442_" x="142.7" y="139.4" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11441_" x="149.5" y="139.4" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11440_" x="156.3" y="139.4" className="st6" width="3.7" height="5.1" />
                </g>
                <g id="XMLID_11428_">
                  <rect id="XMLID_11438_" x="89.3" y="150.1" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11437_" x="96.1" y="150.1" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11436_" x="103" y="150.1" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11435_" x="109.8" y="150.1" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11434_" x="116.6" y="150.1" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11433_" x="123.4" y="150.1" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11432_" x="130.2" y="150.1" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11431_" x="142.7" y="150.1" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11430_" x="149.5" y="150.1" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11429_" x="156.3" y="150.1" className="st6" width="3.7" height="5.1" />
                </g>
                <g id="XMLID_11416_">
                  <rect id="XMLID_11427_" x="89.3" y="160.8" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11426_" x="96.1" y="160.8" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11425_" x="103" y="160.8" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11424_" x="109.8" y="160.8" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11423_" x="116.6" y="160.8" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11421_" x="123.4" y="160.8" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11420_" x="130.2" y="160.8" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11419_" x="142.7" y="160.8" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11418_" x="149.5" y="160.8" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11417_" x="156.3" y="160.8" className="st6" width="3.7" height="5.1" />
                </g>
                <g id="XMLID_11405_">
                  <rect id="XMLID_11415_" x="89.3" y="171.5" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11414_" x="96.1" y="171.5" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11413_" x="103" y="171.5" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11412_" x="109.8" y="171.5" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11411_" x="116.6" y="171.5" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11410_" x="123.4" y="171.5" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11409_" x="130.2" y="171.5" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11408_" x="142.7" y="171.5" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11407_" x="149.5" y="171.5" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11406_" x="156.3" y="171.5" className="st6" width="3.7" height="5.1" />
                </g>
                <g id="XMLID_11394_">
                  <rect id="XMLID_11404_" x="89.3" y="182.2" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11403_" x="96.1" y="182.2" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11402_" x="103" y="182.2" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11401_" x="109.8" y="182.2" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11400_" x="116.6" y="182.2" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11399_" x="123.4" y="182.2" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11398_" x="130.2" y="182.2" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11397_" x="142.7" y="182.2" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11396_" x="149.5" y="182.2" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11395_" x="156.3" y="182.2" className="st6" width="3.7" height="5.1" />
                </g>
                <g id="XMLID_11382_">
                  <rect id="XMLID_11393_" x="89.3" y="192.8" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11392_" x="96.1" y="192.8" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11391_" x="103" y="192.8" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11390_" x="109.8" y="192.8" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11389_" x="116.6" y="192.8" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11388_" x="123.4" y="192.8" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11387_" x="130.2" y="192.8" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11386_" x="142.7" y="192.8" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11385_" x="149.5" y="192.8" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11384_" x="156.3" y="192.8" className="st6" width="3.7" height="5.1" />
                </g>
                <g id="XMLID_11371_">
                  <rect id="XMLID_11381_" x="89.3" y="203.5" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11380_" x="96.1" y="203.5" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11379_" x="103" y="203.5" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11378_" x="109.8" y="203.5" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11377_" x="116.6" y="203.5" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11376_" x="123.4" y="203.5" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11375_" x="130.2" y="203.5" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11374_" x="142.7" y="203.5" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11373_" x="149.5" y="203.5" className="st6" width="3.7" height="5.1" />
                  <rect id="XMLID_11372_" x="156.3" y="203.5" className="st6" width="3.7" height="5.1" />
                </g>
              </g>
              <path
                id="XMLID_11369_"
                className="st5"
                d="M95.5,45.5h58.4v-8c0-2.8-2.3-5.2-5.2-5.2h-48.1c-2.8,0-5.2,2.3-5.2,5.2V45.5z"
              />
              <path id="XMLID_11368_" className="st5" d="M127,32.4h21.9c2.8,0,5,2.4,5,5.3v7.8H127V32.4z" />
            </g>
          </g>
          <g id="XMLID_11345_">
            <g id="XMLID_11362_">
              <path
                id="XMLID_11365_"
                className="st4"
                d="M238,271.3c-2.8-25.6-42.3-45.9-90.6-45.9s-88.7,24.1-83,45.8c2.6,9.9,39,5.5,39,5.5
              l15-1L238,271.3z"
              />
              <path
                id="XMLID_11364_"
                className="st4"
                d="M425.7,271.3c-2.6-25.6-38.7-45.9-82.8-45.9s-80.2,20.3-82.8,45.9H425.7z"
              />
              <path
                id="XMLID_11363_"
                className="st4"
                d="M330.4,271.3c-9.4-40.8-53.5-71.6-106.5-71.6s-97.1,30.9-106.5,71.6H330.4z"
              />
            </g>
            <g id="XMLID_11360_">
              <path
                id="XMLID_11361_"
                className="st4"
                d="M334.6,194.4c0,0-1.6,13.9,5.4,27.1c7,13.2,13.5,8.6,13.5,8.6s7.1-3.5,0.1-16.6
              C346.6,200.3,334.6,194.4,334.6,194.4z"
              />
            </g>
            <g id="XMLID_11358_">
              <path
                id="XMLID_11359_"
                className="st4"
                d="M137.4,200.5c0,0-2.5,11.3,3,20.6c5.5,9.3,11.9,4.5,11.9,4.5s6.8-4,1.3-13.2
              C148.1,203.1,137.4,200.5,137.4,200.5z"
              />
            </g>
            <g id="XMLID_11356_">
              <path
                id="XMLID_11357_"
                className="st4"
                d="M354,181.5c0,0,10.1,12.8,11.2,30.8c1.1,18-8.2,17.9-8.2,17.9s-9.2,1.4-10.3-16.6
              C345.5,195.6,354,181.5,354,181.5z"
              />
            </g>
            <g id="XMLID_11354_">
              <path
                id="XMLID_11355_"
                className="st4"
                d="M157.1,169.5c0,0,11,16.2,10.8,37.8c-0.2,21.6-11.3,20.6-11.3,20.6s-11.1,0.8-11-20.7
              C145.9,185.5,157.1,169.5,157.1,169.5z"
              />
            </g>
            <g id="XMLID_11352_">
              <path
                id="XMLID_11353_"
                className="st4"
                d="M260.5,183.6c0,0-4.9,10.4-1.5,20.8c3.3,10.4,10.6,7.3,10.6,7.3s7.5-2.2,4.2-12.6
              C270.4,188.7,260.5,183.6,260.5,183.6z"
              />
            </g>
            <g id="XMLID_11350_">
              <path
                id="XMLID_11351_"
                className="st4"
                d="M286.6,158.2c0,0,7.2,18.5,2.3,39.4c-4.9,21-15.4,17.3-15.4,17.3s-11-1.9-6.2-22.9
              C272.1,171.1,286.6,158.2,286.6,158.2z"
              />
            </g>
            <g id="XMLID_11348_">
              <path
                id="XMLID_11349_"
                className="st4"
                d="M324,229.8c-1.3-0.8-2.1-2.4-2-3.9c0.2-1.5,1.3-2.9,2.6-3.3c0.8-0.2,1.7-0.2,2.5-0.4
              c0.8-0.2,1.7-0.7,1.9-1.5c0.3-1.1-0.6-2.3-0.2-3.4c0.3-1.1,1.7-1.5,2.7-1.2c1.1,0.3,1.9,1.1,2.9,1.6c1.1,0.7,2.4,1,3.8,1
              c1.1,0,2.1-0.2,3.2-0.1c1.1,0.1,2.2,0.7,2.5,1.8c0.3,0.9-0.1,2,0.4,2.7c0.5,0.8,1.6,0.9,2.3,1.4c1,0.7,1.3,2.3,0.6,3.4
              L324,229.8z"
              />
            </g>
            <g id="XMLID_11346_">
              <path
                id="XMLID_11347_"
                className="st4"
                d="M207.9,200.5c-1.5-1-2.4-3.1-2.1-4.9c0.3-1.8,1.8-3.4,3.5-3.7c1-0.2,2-0.1,3-0.2
              c1-0.1,2.1-0.6,2.4-1.6c0.5-1.3-0.5-2.8,0-4.1c0.5-1.3,2.1-1.7,3.4-1.2c1.2,0.5,2.2,1.5,3.3,2.2c1.3,0.9,2.9,1.4,4.4,1.6
              c1.3,0.1,2.6-0.1,3.8,0.2c1.3,0.3,2.5,1.1,2.8,2.4c0.2,1.1-0.3,2.3,0.3,3.3c0.5,1,1.8,1.2,2.7,1.9c1.2,0.9,1.4,2.9,0.4,4.1
              H207.9z"
              />
            </g>
          </g>
          <g id="XMLID_11341_">
            <g id="XMLID_11342_">
              <path
                id="XMLID_11343_"
                className="st4"
                d="M82.3,268.1c-5.2-3.9-8.5-11.9-7.3-18.9c1.2-7,6.3-12.9,12.3-14.4
              c3.5-0.9,7.2-0.3,10.8-0.8c3.6-0.5,7.4-2.4,8.7-6.3c1.6-5-1.7-10.8-0.1-15.8c1.7-5,7.6-6.4,12-4.7c4.4,1.7,7.9,5.6,11.9,8.5
              c4.7,3.5,10.2,5.6,15.8,6.1c4.6,0.4,9.2-0.2,13.7,0.8c4.5,1,9.1,4.3,10.1,9.4c0.8,4.2-0.9,9.1,0.9,12.8c1.9,3.9,6.5,4.6,9.5,7.3
              c4.1,3.6,4.9,11.3,1.6,16H82.3z"
              />
            </g>
          </g>
          <path
            id="XMLID_11340_"
            className="st7"
            d="M74.3,277.6c0,12.4,81.2,22.5,181.3,22.5s181.3-10.1,181.3-22.5
          c0-12.4-81.2-22.5-181.3-22.5S74.3,265.2,74.3,277.6z"
          />
          <g id="arbre_3_">
            <g id="XMLID_11323_">
              <g id="XMLID_11324_">
                <defs>
                  <path
                    id="XMLID_11325_"
                    d="M68.9,101c6.3-1.1,10.7,5.5,12,11.3c0.7,3.1,0.7,6.7,3.1,8.8c1,0.9,2.3,1.3,3.5,1.9
                  c7,3.6,7.4,10.3,7.6,17.1c0,1.1,0.1,2.3,0.6,3.3c0.7,1.1,1.9,1.7,2.6,2.8c0.5,0.7,0.7,1.6,0.9,2.4c1.8,7.7,0.8,14.7,0.8,22.4
                  c-0.4,54.6-30.1,52-30.1,52c-0.4,0-0.8,0-1.2,0c-7.2-0.3-13.7-4.8-17.9-10.3c-4.4-5.7-6.8-12.8-8.3-19.8
                  c-1.1-5.2-1.5-10.4-1.8-15.7c-0.3-5.7-1.5-11,0.7-16.5c1-2.5,2.6-5,2.6-7.7c0-3-1.8-5.7-1.9-8.7c-0.1-1.8,0.5-3.5,1.2-5.2
                  c1.5-3.9,3.3-8.5,5.4-12.1c1.7-2.9,5.6-4.6,6.6-8c0.4-1.4,0.2-2.8,0.3-4.2c0.2-7,6.3-11.9,12.6-13.6
                  C68.3,101.1,68.6,101,68.9,101z"
                  />
                </defs>
                <linearGradient
                  id="XMLID_794_"
                  gradientUnits="userSpaceOnUse"
                  x1="93.9873"
                  y1="184.3932"
                  x2="0.132"
                  y2="104.6805"
                >
                  <stop offset="0" stopColor={props.color2 ? props.color2 : '#FFA1A1'} />
                  <stop offset="1" stopColor={props.color1 ? props.color1 : '#FF4137'} />
                </linearGradient>
                <use xlinkHref="#XMLID_11325_" overflow="visible" fill="url(#XMLID_794_)" />
                <clipPath id="XMLID_795_">
                  <use xlinkHref="#XMLID_11325_" overflow="visible;" />
                </clipPath>
                <g id="XMLID_11326_" clipPath="url(#XMLID_795_);">
                  <g id="XMLID_11338_">
                    <path
                      id="XMLID_11339_"
                      className="st6"
                      d="M69.9,223.7c0.2,0,0.4-0.2,0.4-0.4l1-134.6c0-0.2-0.2-0.4-0.4-0.4
                    c-0.2,0-0.4,0.2-0.4,0.4l-1,134.6C69.5,223.5,69.7,223.7,69.9,223.7z"
                    />
                  </g>
                  <path
                    id="XMLID_11337_"
                    className="st6"
                    d="M70.5,121.4c-0.1-0.1-10.7-4.5-17.2-12.8c0.1-0.3,0.2-0.6,0.4-0.9
                  c6.2,8.3,17,12.8,17.1,12.9L70.5,121.4z"
                  />
                  <path
                    id="XMLID_11336_"
                    className="st6"
                    d="M70.7,96.2c-0.1,0-4.4-1.8-9.2-5.3c0.1-0.2,0.3-0.5,0.4-0.7c4.7,3.4,9,5.2,9.1,5.2
                  L70.7,96.2z"
                  />
                  <path
                    id="XMLID_11335_"
                    className="st6"
                    d="M70.4,134.6c-0.2-0.1-14-5.9-20.6-16.5c0.1-0.3,0.2-0.7,0.4-1
                  c6.3,10.8,20.4,16.7,20.6,16.8L70.4,134.6z"
                  />
                  <path
                    id="XMLID_11334_"
                    className="st6"
                    d="M70,191.7c-0.2-0.1-20.3-8.5-29.3-24c0-0.5,0-1.1,0.1-1.6
                  c8.6,15.9,29.4,24.7,29.6,24.8L70,191.7z"
                  />
                  <path
                    id="XMLID_11333_"
                    className="st6"
                    d="M70.1,212l-0.3,0.8c-0.2-0.1-17.9-7.5-27.6-21.2c-0.1-0.6-0.2-1.3-0.3-2
                  C51.1,204,69.9,212,70.1,212z"
                  />
                  <path
                    id="XMLID_11332_"
                    className="st6"
                    d="M70.4,156.9c-0.2-0.1-16.8-7.1-25.9-19.9c0.1-0.4,0.2-0.7,0.2-1.1
                  c8.8,13,25.7,20.2,26,20.3L70.4,156.9z"
                  />
                  <path
                    id="XMLID_11331_"
                    className="st6"
                    d="M85.3,101.8c-6.4,6.1-14.3,9.3-14.4,9.3l-0.3-0.8c0.1,0,8.1-3.3,14.4-9.4
                  C85,101.2,85.2,101.5,85.3,101.8z"
                  />
                  <path
                    id="XMLID_11330_"
                    className="st6"
                    d="M70.7,127.3l-0.3-0.8c0.2-0.1,12.2-4.9,19.1-14c0.1,0.3,0.2,0.6,0.3,0.9
                  C82.7,122.5,70.9,127.3,70.7,127.3z"
                  />
                  <path
                    id="XMLID_11329_"
                    className="st6"
                    d="M70.3,177.8L70,177c0.2-0.1,19.9-8,29.2-22.9c0,0.4,0.1,0.9,0.1,1.3
                  C89.7,170,70.6,177.7,70.3,177.8z"
                  />
                  <path
                    id="XMLID_11328_"
                    className="st6"
                    d="M69.8,205.4c0.2-0.1,20.7-8.3,29.7-23.8c-0.1,0.6-0.1,1.3-0.2,1.9
                  c-9.5,14.8-29,22.6-29.2,22.7L69.8,205.4z"
                  />
                  <path
                    id="XMLID_11327_"
                    className="st6"
                    d="M95.1,130.6c0.1,0.3,0.2,0.7,0.2,1c-9.4,11.6-24.7,17.8-24.9,17.9l-0.3-0.8
                  C70.3,148.6,85.8,142.4,95.1,130.6z"
                  />
                </g>
              </g>
            </g>
            <polygon id="XMLID_11322_" className="st6" points="74.4,279.1 67.2,279.1 69.6,191.5 70.6,189.4 			" />
          </g>
          <g id="nuage2_4_">
            <path
              id="XMLID_11308_"
              className="st11"
              d="M202.3,31.9c3.9,0,7.3,1.8,9.5,4.7c1.6-2.8,4.6-4.7,8.1-4.7c1.9,0,3.6,0.5,5,1.5
            c1.8-7.8,8.8-13.6,17.2-13.6c8.9,0,16.2,6.5,17.4,15c3.4,0.2,6.2,2.5,7.4,5.5c3.3,0.1,6,2.7,6.1,6h-6.2h-6.4h-3.2h-6.2h-23.4
            h-0.8h-12.9h-1.9h-21.6c-0.2-0.8-0.3-1.7-0.3-2.5C190.3,37.3,195.7,31.9,202.3,31.9z"
            />
            <g id="XMLID_11223_">
              <path id="XMLID_11307_" className="st6" d="M257.1,28.1c-1.4-2.3-3.3-4.2-5.6-5.6L257.1,28.1z" />
              <path id="XMLID_11306_" className="st6" d="M257.1,28.1l-5.6-5.6C253.7,23.9,255.6,25.8,257.1,28.1z" />
              <path id="XMLID_11303_" className="st6" d="M247.1,20.5c-0.4-0.1-0.7-0.2-1.1-0.3L247.1,20.5z" />
              <path
                id="XMLID_11302_"
                className="st6"
                d="M246,20.3c0.4,0.1,0.7,0.2,1.1,0.3L259,32.5c0.1,0.4,0.2,0.7,0.3,1.1L246,20.3z"
              />
              <path
                id="XMLID_11301_"
                className="st6"
                d="M261.9,35.4l4.9,4.9c0,0,0,0.1,0,0.1c0,0,0,0,0.1,0l6,6h-0.8L260.8,35
              C261.2,35.1,261.6,35.2,261.9,35.4z"
              />
              <path id="XMLID_11299_" className="st6" d="M243.2,19.9c-0.3,0-0.6,0-0.9,0L243.2,19.9z" />
              <path
                id="XMLID_11298_"
                className="st6"
                d="M243.2,19.9l26.6,26.6H269l-26.6-26.6C242.6,19.8,242.9,19.8,243.2,19.9z"
              />
              <path id="XMLID_11296_" className="st6" d="M240.1,19.9c-0.2,0-0.5,0.1-0.7,0.1L240.1,19.9z" />
              <path
                id="XMLID_11295_"
                className="st6"
                d="M240.1,19.9l26.5,26.5h-0.8L239.4,20C239.6,20,239.8,20,240.1,19.9z"
              />
              <path id="XMLID_11294_" className="st6" d="M237.4,20.5c-0.2,0.1-0.4,0.1-0.6,0.2L237.4,20.5z" />
              <path
                id="XMLID_11292_"
                className="st6"
                d="M237.4,20.5l26,26h-0.8l-25.8-25.8C237,20.6,237.2,20.5,237.4,20.5z"
              />
              <path id="XMLID_11291_" className="st6" d="M235,21.3c-0.2,0.1-0.4,0.2-0.6,0.3L235,21.3z" />
              <path
                id="XMLID_11289_"
                className="st6"
                d="M235,21.3l25.1,25.1h-0.8l-24.9-24.9C234.6,21.5,234.8,21.4,235,21.3z"
              />
              <path id="XMLID_11288_" className="st6" d="M232.9,22.4c-0.2,0.1-0.3,0.2-0.5,0.3L232.9,22.4z" />
              <path
                id="XMLID_11286_"
                className="st6"
                d="M232.9,22.4l24,24h-0.8l-23.7-23.7C232.6,22.6,232.7,22.5,232.9,22.4z"
              />
              <path id="XMLID_11284_" className="st6" d="M231,23.7c-0.2,0.1-0.3,0.2-0.4,0.4L231,23.7z" />
              <path
                id="XMLID_11283_"
                className="st6"
                d="M231,23.7l22.7,22.7h-0.8l-22.3-22.3C230.7,24,230.9,23.9,231,23.7z"
              />
              <path id="XMLID_11282_" className="st6" d="M229.4,25.3c-0.1,0.1-0.3,0.3-0.4,0.4L229.4,25.3z" />
              <path
                id="XMLID_11280_"
                className="st6"
                d="M229.4,25.3l21.1,21.1h-0.8L229,25.7C229.1,25.6,229.2,25.4,229.4,25.3z"
              />
              <path id="XMLID_11278_" className="st6" d="M227.9,27c-0.1,0.2-0.2,0.3-0.3,0.5L227.9,27z" />
              <path
                id="XMLID_11277_"
                className="st6"
                d="M227.9,27l19.4,19.4h-0.8l-18.9-18.9C227.7,27.4,227.8,27.2,227.9,27z"
              />
              <path id="XMLID_11275_" className="st6" d="M226.6,29c-0.1,0.2-0.2,0.4-0.3,0.5L226.6,29z" />
              <path
                id="XMLID_11274_"
                className="st6"
                d="M226.6,29l17.4,17.4h-0.8l-16.9-16.9C226.5,29.4,226.5,29.2,226.6,29z"
              />
              <path id="XMLID_11272_" className="st6" d="M225.6,31.2c-0.1,0.2-0.1,0.4-0.2,0.6L225.6,31.2z" />
              <path
                id="XMLID_11271_"
                className="st6"
                d="M225.6,31.2l15.2,15.2H240l-14.6-14.6C225.5,31.6,225.6,31.4,225.6,31.2z"
              />
              <path id="XMLID_11269_" className="st6" d="M224.1,32.9c-0.4-0.2-0.9-0.4-1.4-0.6L224.1,32.9z" />
              <path
                id="XMLID_11268_"
                className="st6"
                d="M224.1,32.9l13.5,13.5h-0.8l-14.1-14.1C223.2,32.5,223.7,32.7,224.1,32.9z"
              />
              <path id="XMLID_11267_" className="st6" d="M219.9,31.9c-0.3,0-0.5,0-0.8,0L219.9,31.9z" />
              <path
                id="XMLID_11264_"
                className="st6"
                d="M219.9,31.9l14.5,14.5h-0.8l-14.5-14.5C219.4,31.9,219.6,31.9,219.9,31.9z"
              />
              <path id="XMLID_11262_" className="st6" d="M217.1,32.3c-0.2,0.1-0.4,0.1-0.6,0.2L217.1,32.3z" />
              <path
                id="XMLID_11261_"
                className="st6"
                d="M217.1,32.3l14.1,14.1h-0.8l-13.9-13.9C216.7,32.5,216.9,32.4,217.1,32.3z"
              />
              <path id="XMLID_11260_" className="st6" d="M214.9,33.4c-0.2,0.1-0.3,0.2-0.5,0.3L214.9,33.4z" />
              <path
                id="XMLID_11258_"
                className="st6"
                d="M214.9,33.4L228,46.4h-0.3h-0.5l-12.7-12.7C214.6,33.6,214.8,33.5,214.9,33.4z"
              />
              <path id="XMLID_11257_" className="st6" d="M213.2,34.8c-0.1,0.1-0.3,0.3-0.4,0.4L213.2,34.8z" />
              <path
                id="XMLID_11255_"
                className="st6"
                d="M213.2,34.8l11.6,11.6H224l-11.2-11.2C212.9,35.1,213,34.9,213.2,34.8z"
              />
              <path id="XMLID_11253_" className="st6" d="M209.3,34.1c-0.6-0.4-1.3-0.8-2-1.1L209.3,34.1z" />
              <path
                id="XMLID_11252_"
                className="st6"
                d="M209.3,34.1l12.3,12.3h-0.8L207.3,33C208,33.3,208.7,33.7,209.3,34.1z"
              />
              <path id="XMLID_11250_" className="st6" d="M204,32c-0.3,0-0.6-0.1-0.9-0.1L204,32z" />
              <path id="XMLID_11249_" className="st6" d="M204,32l14.4,14.4h-0.8L203,31.9C203.3,31.9,203.6,32,204,32z" />
              <path id="XMLID_11248_" className="st6" d="M200.7,32c-0.2,0-0.5,0.1-0.7,0.1L200.7,32z" />
              <path
                id="XMLID_11246_"
                className="st6"
                d="M200.7,32l14.4,14.4h-0.8L200,32.1C200.3,32.1,200.5,32,200.7,32z"
              />
              <path id="XMLID_11245_" className="st6" d="M198.2,32.7c-0.2,0.1-0.4,0.1-0.6,0.2L198.2,32.7z" />
              <path
                id="XMLID_11243_"
                className="st6"
                d="M198.2,32.7l13.8,13.8h-0.8l-13.5-13.5C197.8,32.8,198,32.7,198.2,32.7z"
              />
              <path id="XMLID_11242_" className="st6" d="M196,33.7c-0.2,0.1-0.3,0.2-0.5,0.3L196,33.7z" />
              <path
                id="XMLID_11240_"
                className="st6"
                d="M196,33.7l12.7,12.7h-0.8L195.5,34C195.7,33.9,195.8,33.8,196,33.7z"
              />
              <path id="XMLID_11239_" className="st6" d="M194.2,35.1c-0.1,0.1-0.3,0.3-0.4,0.4L194.2,35.1z" />
              <path
                id="XMLID_11237_"
                className="st6"
                d="M194.2,35.1l11.3,11.3h-0.8l-10.9-10.9C193.9,35.4,194,35.2,194.2,35.1z"
              />
              <path id="XMLID_11235_" className="st6" d="M192.7,36.8c-0.1,0.2-0.2,0.3-0.3,0.5L192.7,36.8z" />
              <path
                id="XMLID_11234_"
                className="st6"
                d="M192.7,36.8l9.6,9.6h-0.8l-9.2-9.2C192.4,37.1,192.5,37,192.7,36.8z"
              />
              <path id="XMLID_11233_" className="st6" d="M191.5,38.8c-0.1,0.2-0.2,0.4-0.3,0.6L191.5,38.8z" />
              <path
                id="XMLID_11231_"
                className="st6"
                d="M191.5,38.8l7.6,7.6h-0.8l-7.1-7.1C191.3,39.2,191.4,39,191.5,38.8z"
              />
              <path id="XMLID_11229_" className="st6" d="M190.6,41.2c-0.1,0.2-0.1,0.5-0.1,0.7L190.6,41.2z" />
              <path
                id="XMLID_11228_"
                className="st6"
                d="M190.6,41.2l5.2,5.2h-0.8l-4.6-4.6C190.5,41.6,190.6,41.4,190.6,41.2z"
              />
              <path id="XMLID_11226_" className="st6" d="M190.3,44.1c0,0.3,0,0.6,0,0.9L190.3,44.1z" />
              <path
                id="XMLID_11224_"
                className="st6"
                d="M190.3,44.1l2.3,2.3h-0.8l-1.5-1.5C190.3,44.7,190.3,44.4,190.3,44.1z"
              />
            </g>
          </g>
          <g id="XMLID_11164_">
            <g id="XMLID_11172_">
              <path
                id="XMLID_11205_"
                className="st34"
                d="M180.1,124.9c0.8,2.1,0.5,4.6,1.3,6.8c0.8,2.1,2.4,3.7,4.2,5c1.3,1,2.8,1.9,3.5,3.4
              c1.6,3.2-1.1,7.3,0.3,10.7c0.6,1.5,2.1,2.7,2.3,4.4c0.2,1.3-0.5,2.5-1.5,3.3c-1,0.8-2.3,1.2-3.5,1.3c-1.1,0.1-2.2,0.1-3.2,0
              c-1.2-0.2-2.4-0.5-3.5-0.7c-2.5-0.5-5.1-0.3-7.5,0.3c-1.9,0.5-3.7,1.4-5.6,1.4c-1.3,0-2.5-0.3-3.7-0.8c-1.3-0.5-2.6-1.1-3.6-2
              c-1.5-1.3-2.3-3.2-2.8-5.1c-0.5-1.9-0.7-3.9-1.1-5.8c-0.6-2.5-1.6-4.8-3.1-6.9c-0.6-0.9-1.3-1.8-1.6-2.8
              c-0.2-0.7-0.2-1.4-0.2-2.2c0.3-3.1,2.1-6.1,4.9-7.6c0.7-0.4,1.4-0.7,2-1.2c0.6-0.5,1.1-1.2,1.5-1.8c0.9-1.2,1.7-2.4,2.7-3.6
              c0.5-0.6,1-1.2,1.6-1.6c0.8-0.5,1.7-0.7,2.6-0.8C170.9,117.8,178.2,120,180.1,124.9z"
              />
              <g id="XMLID_11202_">
                <path
                  id="XMLID_11204_"
                  className="st16"
                  d="M155.7,266.5c0,0,1,9.5-1,10.5c-3.5,1.9-10,3.8-9.4,5.5c0.5,1.7,16,1.7,16.5,0.2
                c0.4-1.5-1.3-6.2,0.5-15.3L155.7,266.5z"
                />
                <path
                  id="XMLID_11203_"
                  className="st37"
                  d="M161.7,279.4c0.2,1.7,0.3,2.9,0.2,3.4c-0.4,1.5-15.9,1.5-16.5-0.2
                c-0.4-1.2,3-2.6,6.3-4C152.4,279.8,154,281.8,161.7,279.4z"
                />
              </g>
              <g id="XMLID_11199_">
                <path
                  id="XMLID_11201_"
                  className="st16"
                  d="M184.8,266.3c0,0,2.6,9.2,0.8,10.6c-3.1,2.5-9.2,5.4-8.4,7c0.8,1.6,16.1-1,16.3-2.6
                c0.2-1.6-2.3-5.9-2.1-15.1L184.8,266.3z"
                />
                <path
                  id="XMLID_11200_"
                  className="st37"
                  d="M192.8,277.9c0.5,1.6,0.8,2.8,0.7,3.3c-0.2,1.6-15.4,4.1-16.3,2.6
                c-0.6-1.2,2.5-3.1,5.5-5C183.7,279.9,185.7,281.6,192.8,277.9z"
                />
              </g>
              <path
                id="XMLID_11198_"
                className="st16"
                d="M149.8,157.9c0,0-3.3,4.4-6,4.4c-2.7,0-11.9-11.5-11.9-11.5l-2.2,3.5
              c0,0,7.7,16.8,14.8,17c7,0.1,12.3-7.7,12.2-8.1c-0.1-0.4-4.6-5.2-4.6-5.2H149.8z"
              />
              <path
                id="XMLID_11197_"
                className="st37"
                d="M157.6,182.5c0,0-4.2,5.1-6.1,11.1c-1.9,6,3.1,76.6,3.1,76.6h8.4c0,0,4.5-62.9,4.5-63.5
              c0-2.2,16.5,63.5,16.5,63.5h8.4c0,0-4.5-76.9-15.1-87.7l-9.9,0.6L157.6,182.5z"
              />
              <path
                id="XMLID_11196_"
                className="st37"
                d="M157.6,179.9v2.6c0,0,5,4.9,19.8,0l0-2.6l-12.9-0.8L157.6,179.9z"
              />
              <path
                id="XMLID_11195_"
                className="st12"
                fill={props.color1 ? props.color1 : '#FF4137'}
                d="M162.6,148c0,0-5.2-0.2-7.9,1.6c-1.9,1.3-6.1,8.7-6.1,8.7l4.8,4.1c0,0-1.1,4.5,3.3,6.7
              l0.8,10.8c0,0,8.4,4.9,19.8,0c0,0,2.2-20.2,4.2-18.4c2,1.8,3.3,3.3,3.3,3.3l7.6-7.5c0,0-8.3-8.3-11-9.6
              c-6.4-3-11.6-0.1-11.6-0.1L162.6,148z"
              />
              <path
                id="XMLID_11194_"
                className="st16"
                d="M185.5,164.1c0,0,4.4,5.1,3.9,6.6c-0.5,1.4-8.3,13.1-9.3,15.4c-1,2.2-0.7,3.5-0.7,3.5
              l4,1.9c0,0,0.2-3.1,1.1-4.1c0.9-0.9,14-14.4,13.7-18.7c-0.3-4.3-6.3-10.8-6.3-10.8L185.5,164.1z"
              />
              <g id="XMLID_11181_">
                <path
                  id="XMLID_11193_"
                  className="st16"
                  d="M160.3,131.5c0,0-0.6-1.1-1.2-0.8c-1.5,0.9-0.2,2.5,0.7,3L160.3,131.5z"
                />
                <path
                  id="XMLID_11192_"
                  className="st16"
                  d="M170.5,119.8c4.2,0.8,7.3,4.7,7,9c-0.1,1.4-0.5,2.7-1.2,3.9c-1.5,2.8-2.8,5.1-4.2,6.7
                c-1.4,1.6-2.2,3.7-2.2,5.9l0.1,2.2c-5.3,1.9-7.3,0.6-7.3,0.6l0.7-6.4l0,0c-5.3-1.3-3.5-11.1-3.1-14l0,0c0-0.1,0-0.2,0-0.3
                C161,122.4,165.6,118.9,170.5,119.8z"
                />
                <path
                  id="XMLID_11191_"
                  className="st37"
                  d="M170.2,128.5c1.3,1.9,2.7,3.9,3.6,6c0.1,0.2,0.8,2,0.5,2.2c1.5-0.9,2.6-2.4,3.5-3.9
                c1.6-2.6,1.6-5.9,0.3-8.6c-1.3-2.7-3.8-4.3-6.6-4.8c-3.1-0.6-6.6,0-8.8,2.4c-2.1,2.2-2.5,5.3-3,8.2c0.6-3.2,5.2-5.1,8-6
                c-0.1,0,1.6,3,1.7,3.2C169.6,127.6,169.9,128.1,170.2,128.5z"
                />
                <path
                  id="XMLID_11190_"
                  className="st16"
                  d="M173.5,134.7c0.2-0.3,0.4-0.4,0.7-0.5c0.6-0.2,1.7-0.3,2.3,0.5
                c0.9,1.2-1.5,3.7-3.4,2.1C173.1,136.8,172.6,136.1,173.5,134.7z"
                />
                <path
                  id="XMLID_11189_"
                  className="st37"
                  d="M161.7,131.7c0-0.4,0.3-0.7,0.8-0.7c0.4,0,0.7,0.3,0.7,0.8c0,0.4-0.3,0.7-0.8,0.7
                C162,132.5,161.7,132.2,161.7,131.7z"
                />
                <path
                  id="XMLID_11187_"
                  className="st37"
                  d="M168.6,133.3c0-0.4,0.3-0.7,0.8-0.7c0.4,0,0.7,0.3,0.7,0.8c0,0.4-0.3,0.7-0.8,0.7
                C168.9,134.1,168.6,133.7,168.6,133.3z"
                />
                <path
                  id="XMLID_11186_"
                  className="st39"
                  d="M162.4,137c0,0,1-0.7,1.4-0.6c0.4,0.1,0.6,0.6,0.6,0.6s0.2-0.5,0.7-0.4
                c0.5,0,1.4,1.3,1.4,1.3s-1.4,2-2.8,1.7c-1.4-0.3-1.3-2.4-1.3-2.4L162.4,137z"
                />
                <path
                  id="XMLID_11185_"
                  className="st37"
                  d="M171,132.5c0.1,0,0.2,0,0.3-0.1c0.1-0.1,0.1-0.3,0-0.4c0,0-0.9-0.9-2.3-1
                c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3c1.2,0.1,1.9,0.8,1.9,0.8C170.8,132.4,170.9,132.5,171,132.5z"
                />
                <path
                  id="XMLID_11184_"
                  className="st37"
                  d="M163.8,130.3c0.1,0,0.2-0.1,0.2-0.1c0.1-0.1,0.1-0.3-0.1-0.4c0,0-1.1-0.7-2.5-0.5
                c-0.2,0-0.3,0.2-0.3,0.4c0,0.2,0.2,0.3,0.4,0.3c1.2-0.2,2,0.4,2,0.4C163.7,130.3,163.7,130.3,163.8,130.3z"
                />
                <path
                  id="XMLID_11183_"
                  className="st38"
                  d="M164.9,135.8c-0.9-0.2-1.1-0.9-1.1-1.3c0-0.1,0-0.1,0.1-0.2c0.9-0.9,1-2.3,1-2.3
                c0-0.1,0.1-0.3,0.3-0.2c0.1,0,0.3,0.1,0.2,0.3c0,0.1-0.1,1.6-1.1,2.6c0,0.2,0.2,0.7,1,0.8c0.1,0,0.3,0.1,0.2,0.3
                c0,0.1-0.1,0.3-0.3,0.2C165.2,135.9,165.1,135.8,164.9,135.8z"
                />
                <path
                  id="XMLID_11182_"
                  className="st40"
                  d="M162.4,137l4.1,0.8c0,0-1.5,1-2.6,0.8C162.8,138.5,162.4,137,162.4,137z"
                />
              </g>
              <g id="XMLID_11178_">
                <path
                  id="XMLID_11180_"
                  className="st16"
                  d="M181.5,183.7c0,0-3.4,4.8-3.1,6c0.4,1.1,1.8,4.3,1.9,4.8c0.1,0.6,0,3.5,0.3,4
                c0.3,0.5,1-3.2,1-3.2s-0.2,3.2,0.4,3.4c0.6,0.2,1.1-3.2,1.1-3.2s-0.3,3.3,0.3,3.3c0.5,0,0.9-3.1,0.9-3.1s-0.2,2.5,0.2,2.5
                c0.4,0,1.4-4.1,0.6-5.6c-2-3.4-1.4-5.3-1.4-5.3L181.5,183.7z"
                />
                <path
                  id="XMLID_11179_"
                  className="st16"
                  d="M179.3,187.2c0,0-1.7,2.9-1.7,4s-0.3,3.3,0.1,3.3c0.5,0,1.1-3.1,1.4-3.2
                c0.3-0.1,0.3-1.5,0.3-1.5L179.3,187.2z"
                />
              </g>
              <path
                id="XMLID_11177_"
                className="st37"
                d="M170.5,167.6c3.8,0,5.4-3.8,5.4-3.8c0-0.1,0-0.2-0.1-0.2c-0.1,0-0.2,0-0.2,0.1
              c0,0-1.5,3.7-5.2,3.7c-3.6,0-5-2.6-5-2.7c0-0.1-0.1-0.1-0.2-0.1c-0.1,0-0.1,0.1-0.1,0.2C165.2,164.9,166.7,167.6,170.5,167.6z"
              />
              <path
                id="XMLID_11176_"
                className="st37"
                d="M153.4,162.6c0.1,0,0.1-0.1,0.1-0.1c0,0,0.3-2.6,2.3-4.4c0.1-0.1,0.1-0.1,0-0.2
              c-0.1-0.1-0.1-0.1-0.2,0c-2,1.9-2.4,4.5-2.4,4.6C153.3,162.5,153.3,162.6,153.4,162.6C153.4,162.6,153.4,162.6,153.4,162.6z"
              />
              <path
                id="XMLID_11173_"
                className="st7"
                d="M162,183.3c0-1.4,1.1-2.5,2.5-2.5c1.4,0,2.5,1.1,2.5,2.5c0,1.4-1.1,2.5-2.5,2.5
              C163.1,185.8,162,184.7,162,183.3z M163.2,183.3c0,0.7,0.6,1.4,1.4,1.4c0.7,0,1.4-0.6,1.4-1.4c0-0.7-0.6-1.4-1.4-1.4
              C163.8,182,163.2,182.6,163.2,183.3z"
              />
            </g>
            <g id="XMLID_11165_">
              <path
                id="XMLID_11171_"
                className="st85"
                d="M134.7,154.5c0,0-1.3-3-3.1-4.2c-1.7-1.2-3.1-0.7-3.1-0.7l-1.9-1.2c0,0-1.1,5.9,3.4,8.6
              C130.5,157.2,134.7,154.5,134.7,154.5z"
              />
              <path
                id="XMLID_11170_"
                className="st37"
                d="M132.1,141.9l-6.6,1.9c-0.1,0-0.1,0.1-0.1,0.2l3.8,13.3c0,0.1,0.1,0.1,0.2,0.1l6.6-1.9
              c0.1,0,0.1-0.1,0.1-0.2l-3.8-13.3C132.2,141.9,132.2,141.8,132.1,141.9z"
              />
              <path
                id="XMLID_11169_"
                className="st85"
                d="M126,150c-0.2,0-0.4-0.1-0.6-0.2c-0.3-0.3-0.3-0.8,0-1.2l1.4-1.5c0.3-0.3,0.8-0.3,1.2,0
              c0.3,0.3,0.3,0.8,0,1.2l-1.4,1.5C126.4,149.9,126.2,150,126,150z"
              />
              <path
                id="XMLID_11168_"
                className="st85"
                d="M126.5,151.3c-0.2,0-0.4-0.1-0.6-0.2c-0.3-0.3-0.3-0.8,0-1.2l1.4-1.5
              c0.3-0.3,0.8-0.3,1.2,0c0.3,0.3,0.3,0.8,0,1.2l-1.4,1.5C126.9,151.2,126.7,151.3,126.5,151.3z"
              />
              <path
                id="XMLID_11167_"
                className="st85"
                d="M127,152.6c-0.2,0-0.4-0.1-0.6-0.2c-0.3-0.3-0.3-0.8,0-1.2l1.4-1.5
              c0.3-0.3,0.8-0.3,1.2,0c0.3,0.3,0.3,0.8,0,1.2l-1.4,1.5C127.5,152.5,127.3,152.6,127,152.6z"
              />
              <path
                id="XMLID_11166_"
                className="st85"
                d="M127.9,153.4c-0.1,0-0.3,0-0.4-0.1c-0.2-0.2-0.3-0.5-0.1-0.8l1.3-1.5
              c0.2-0.2,0.5-0.3,0.8-0.1c0.2,0.2,0.3,0.5,0.1,0.8l-1.3,1.5C128.2,153.3,128.1,153.4,127.9,153.4z"
              />
            </g>
          </g>
          <g id="XMLID_10190_">
            <g id="XMLID_10425_">
              <g id="XMLID_10449_">
                <g id="XMLID_10451_">
                  <path
                    id="XMLID_11163_"
                    className="st86"
                    d="M318.3,78.9H213.9c-5.5,0-8.2,5.1-8.2,6.1v190.4l6.6,5.9h105.5l8.2-6.2V85.4
                  C325.9,80.1,319.3,78.9,318.3,78.9z"
                  />
                  <path
                    id="XMLID_11103_"
                    className="st34"
                    d="M318.8,282.4H212.7c-4.5,0-8.2-3.7-8.2-8.2V86.1c0-4.5,3.7-8.2,8.2-8.2h106.1
                  c4.5,0,8.2,3.7,8.2,8.2v188.2C327,278.7,323.3,282.4,318.8,282.4z M212.7,80c-3.4,0-6.1,2.7-6.1,6.1v188.2
                  c0,3.4,2.7,6.1,6.1,6.1h106.1c3.4,0,6.1-2.7,6.1-6.1V86.1c0-3.4-2.7-6.1-6.1-6.1H212.7z"
                  />
                </g>
                <path
                  id="XMLID_10450_"
                  className="st34"
                  d="M317.9,281.4H213.2c-7.7,0-7.6-6.2-7.6-13.9l0,0h120.3l0,0
                C325.9,275.1,325.6,281.4,317.9,281.4z"
                />
              </g>
              <g id="XMLID_10445_">
                <path
                  id="XMLID_10448_"
                  className="st34"
                  d="M230.8,99.5h-13.6c-0.6,0-1-0.5-1-1c0-0.6,0.5-1,1-1h13.6c0.6,0,1,0.5,1,1
                C231.9,99,231.4,99.5,230.8,99.5z"
                />
                <path
                  id="XMLID_10447_"
                  className="st34"
                  d="M230.8,94.3h-13.6c-0.6,0-1-0.5-1-1c0-0.6,0.5-1,1-1h13.6c0.6,0,1,0.5,1,1
                C231.9,93.9,231.4,94.3,230.8,94.3z"
                />
                <path
                  id="XMLID_10446_"
                  className="st34"
                  d="M230.8,89.2h-13.6c-0.6,0-1-0.5-1-1c0-0.6,0.5-1,1-1h13.6c0.6,0,1,0.5,1,1
                C231.9,88.7,231.4,89.2,230.8,89.2z"
                />
              </g>
              <path
                id="XMLID_10444_"
                className="st6"
                d="M279.8,222.3h-28c-24.9,0-45.1,20.2-45.1,45.1v0h118.2v0
              C324.9,242.5,304.7,222.3,279.8,222.3z"
              />
              <g id="XMLID_10441_">
                <ellipse
                  id="XMLID_10443_"
                  transform="matrix(0.4596 -0.8881 0.8881 0.4596 -74.524 368.7685)"
                  className="st87"
                  cx="265.8"
                  cy="245.6"
                  rx="13.6"
                  ry="13.6"
                />
                <path
                  id="XMLID_10442_"
                  className="st6"
                  d="M264.1,252.7c-0.2,0-0.5-0.1-0.6-0.3l-5.6-6.7c-0.3-0.3-0.2-0.8,0.1-1.1
                c0.3-0.3,0.8-0.2,1.1,0.1l5,6l9-11.4c0.3-0.3,0.8-0.4,1.1-0.1c0.3,0.3,0.4,0.8,0.1,1.1l-9.6,12.2
                C264.5,252.6,264.3,252.7,264.1,252.7C264.1,252.7,264.1,252.7,264.1,252.7z"
                />
              </g>
              <path
                id="XMLID_10440_"
                className="st6"
                d="M277.8,214.6h-23.5c-21,0-38.1-17.1-38.1-38.1v0c0-21,17.1-38.1,38.1-38.1h23.5
              c21,0,38.1,17.1,38.1,38.1v0C315.9,197.5,298.7,214.6,277.8,214.6z"
              />
              <path
                id="XMLID_10439_"
                className="st6"
                d="M302.9,131.8h-73.8c-7.1,0-13-5.8-13-13l0,0c0-7.1,5.8-13,13-13h73.8c7.1,0,13,5.8,13,13
              l0,0C315.9,125.9,310,131.8,302.9,131.8z"
              />
              <g id="XMLID_10427_">
                <g id="XMLID_10436_">
                  <path
                    id="XMLID_10438_"
                    className="st34"
                    d="M245.5,155.7c0-4.6-3.7-8.3-8.3-8.3c-4.6,0-8.3,3.7-8.3,8.3s7.7,14.4,8.3,14.4
                  C237.7,170.1,245.5,160.3,245.5,155.7L245.5,155.7z"
                  />
                  <path
                    id="XMLID_10437_"
                    className="st6"
                    d="M242.9,156c0-3.2-2.6-5.7-5.7-5.7c-3.2,0-5.7,2.6-5.7,5.7c0,3.2,2.6,5.7,5.7,5.7
                  C240.3,161.7,242.9,159.1,242.9,156L242.9,156z"
                  />
                </g>
                <rect id="XMLID_10435_" x="251.4" y="155.8" className="st11" width="51" height="3.9" />
                <rect id="XMLID_10434_" x="251.4" y="163.8" className="st11" width="51" height="3.9" />
                <rect id="XMLID_10433_" x="251.4" y="185.9" className="st11" width="51" height="3.9" />
                <rect id="XMLID_10432_" x="251.4" y="193.8" className="st11" width="51" height="3.9" />
                <g id="XMLID_10428_">
                  <path
                    id="XMLID_10431_"
                    className="st34"
                    d="M228.8,190.4c0-4.6,3.7-8.3,8.3-8.3c4.6,0,8.3,3.7,8.3,8.3c0,4.6-3.7,8.3-8.3,8.3
                  C232.6,198.8,228.8,195,228.8,190.4z"
                  />
                  <rect id="XMLID_10430_" x="236.9" y="184.4" className="st6" width="1.1" height="6.3" />

                  <rect
                    id="XMLID_10429_"
                    x="239.5"
                    y="187.8"
                    transform="matrix(-1.836970e-16 1 -1 -1.836970e-16 430.9672 -49.114)"
                    className="st6"
                    width="1.1"
                    height="6.3"
                  />
                </g>
              </g>
            </g>
            <g id="XMLID_10401_">
              <defs>
                <path
                  id="XMLID_10402_"
                  d="M223.8,118.4c0-5,4-9,9-9c5,0,9,4,9,9c0,5-4,9-9,9C227.8,127.4,223.8,123.3,223.8,118.4z"
                />
              </defs>
              <clipPath id="XMLID_796_">
                <use xlinkHref="#XMLID_10402_" overflow="visible;" />
              </clipPath>

              <rect
                id="XMLID_10424_"
                x="221.7"
                y="108"
                transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 465.0038 236.9416)"
                clipPath="url(#XMLID_796_)"
                fill="#9297A5;"
                width="21.6"
                height="20.9"
              />
              <path
                id="XMLID_10423_"
                clipPath="url(#XMLID_796_)"
                fill="#1B202D"
                d="M234.3,110.8c0.1,0,0.3,0,0.4,0.1
              c0.1,0.1,0.1,0.3,0.2,0.4c0.2,0.4,0.8,0.5,1.2,0.6c0.5,0.1,1,0.3,1,0.8c0,0.1,0,0.2,0,0.3c0,0.1,0.1,0.1,0.1,0.2
              c0.3,0.3,0.8,0.4,1.1,0.6c0.4,0.2,0.7,0.6,0.6,1c0,0.2-0.2,0.4-0.2,0.6c0,0.3,0.2,0.6,0.4,0.9c0.4,0.5,0.8,0.9,1.2,1.4
              c0.2,0.2,0.3,0.4,0.4,0.6c0,0.4-0.4,0.8-0.5,1.2c-0.1,0.5,0.3,1,0.4,1.5c0.2,0.7-0.3,1.5-1.1,1.6c-0.2,0-0.3,0-0.5,0.1
              c-0.2,0.2-0.2,0.5-0.3,0.7c-0.1,0.6-0.5,1.1-1.1,1.3c-1.1,0.4-2.2-0.3-3.4-0.4c-0.7,0-1.4,0.1-2.1,0.2c-0.8,0-1.6-0.1-2.4-0.5
              c-0.1,0-0.2-0.1-0.2-0.2c-0.1-0.2-0.1-0.4-0.1-0.7c-0.1-0.7-0.9-1-1.5-1.1c-0.7-0.1-1.4-0.3-1.6-1c-0.1-0.3,0-0.7-0.1-1.1
              c-0.1-0.4-0.6-0.6-0.8-1c-0.3-0.5-0.1-1.2,0.1-1.7c0.3-0.5,0.6-1.1,0.6-1.7c0-0.4-0.1-0.8-0.1-1.2c0-0.4,0.1-0.8,0.4-1.1
              c0.4-0.3,0.9-0.1,1.4-0.2c1.1-0.3,1.3-2,2.5-2.2c0.2,0,0.4,0,0.7,0c0.6,0,1-0.2,1.6-0.3C233.3,110.8,233.8,110.8,234.3,110.8z"
              />
              <path
                id="XMLID_10422_"
                clipPath="url(#XMLID_796_)"
                fill={props.color1 ? props.color1 : '#FF4137'}
                d="M235,121.9c0,0,4.6,1.5,5.3,2.4
              c0.7,0.9,1.5,5.7,1.5,5.7l-16-0.6c0,0,0.8-4.9,2.2-6c1.3-1.1,4.6-1.3,4.6-1.3L235,121.9z"
              />
              <g id="XMLID_10403_" clipPath="url(#XMLID_796_)">
                <path
                  id="XMLID_10421_"
                  className="st38"
                  d="M229.6,116.9c0,0-0.3-0.4-0.5-0.2c-0.5,0.5,0.2,1,0.5,1L229.6,116.9z"
                />
                <path
                  id="XMLID_10420_"
                  className="st85"
                  d="M229.2,115.4L229.2,115.4c0,0,0-0.1,0-0.1c-0.3-1.9,1.1-3.7,3-3.8
                c1.6-0.1,3.1,0.9,3.5,2.5c0.1,0.6,0.1,1.2,0,1.7c-0.2,1-0.4,1.9-0.7,2.5c-0.5,1.1-0.5,2.3-0.2,3.5l0.1,0.2
                c-1.8,1.3-2.8,0.3-2.8,0.3l-0.2-1.5c0-0.2-0.2-0.4-0.4-0.4C229.3,120.2,229.4,116.5,229.2,115.4z"
                />
                <path
                  id="XMLID_10419_"
                  className="st38"
                  d="M230.9,118.6c0,0,0.2-0.2,0.4-0.1c0.1,0,0.2,0.2,0.2,0.2s0.1-0.2,0.3-0.2
                c0.2,0,0.7,0.1,0.7,0.1s-0.5,0.8-1,0.6C231,119.1,231,118.6,230.9,118.6L230.9,118.6z"
                />
                <path
                  id="XMLID_10418_"
                  className="st34"
                  d="M232.8,116.6c0-0.2,0.1-0.4,0.3-0.4c0.2,0,0.4,0.1,0.4,0.3c0,0.2-0.1,0.4-0.3,0.4
                C233,116.9,232.8,116.8,232.8,116.6z"
                />
                <path
                  id="XMLID_10414_"
                  className="st34"
                  d="M230,116.6c0-0.2,0.1-0.4,0.3-0.4c0.2,0,0.4,0.1,0.4,0.3c0,0.2-0.1,0.4-0.3,0.4
                C230.2,116.9,230.1,116.8,230,116.6z"
                />
                <path
                  id="XMLID_10409_"
                  className="st34"
                  d="M231.4,118.9c0.6,0.1,1.2-0.3,1.2-0.3c0,0,0,0,0-0.1c0,0,0,0-0.1,0c0,0-1,0.7-1.7,0
                c0,0,0,0-0.1,0c0,0,0,0,0,0.1C231.1,118.8,231.3,118.9,231.4,118.9z"
                />
                <path
                  id="XMLID_10408_"
                  className="st34"
                  d="M233.7,115.8C233.8,115.8,233.8,115.8,233.7,115.8c0.1-0.1,0.1-0.2,0-0.2
                c0,0-0.5-0.2-1,0c-0.1,0-0.1,0.1-0.1,0.2c0,0.1,0.1,0.1,0.2,0.1C233.3,115.6,233.6,115.8,233.7,115.8
                C233.7,115.8,233.7,115.8,233.7,115.8z"
                />
                <path
                  id="XMLID_10407_"
                  className="st34"
                  d="M230.7,115.8C230.7,115.8,230.8,115.8,230.7,115.8c0.1-0.1,0.1-0.2,0-0.2
                c0,0-0.4-0.2-1,0c-0.1,0-0.1,0.1-0.1,0.2c0,0.1,0.1,0.1,0.2,0.1C230.2,115.7,230.6,115.8,230.7,115.8
                C230.6,115.8,230.7,115.8,230.7,115.8z"
                />
                <path
                  id="XMLID_10406_"
                  className="st38"
                  d="M231.6,117.9c0.1,0,0.2-0.1,0.2-0.1c0,0,0-0.1,0-0.1c0,0-0.1,0-0.1,0
                c0,0-0.2,0.2-0.5,0c-0.1,0-0.1-0.1-0.1-0.1c0,0,0-0.1,0.1-0.1c0.1-0.2,0.3-0.4,0.3-0.9c0,0,0-0.1-0.1-0.1c0,0-0.1,0-0.1,0.1
                c0,0.5-0.1,0.7-0.3,0.9c-0.1,0.1-0.1,0.2-0.1,0.2c0,0.1,0,0.1,0.1,0.2C231.3,117.9,231.5,117.9,231.6,117.9z"
                />
                <path
                  id="XMLID_10405_"
                  className="st34"
                  d="M234.8,116.5c-0.1-0.2-0.1-0.3-0.1-0.5c-0.2-0.4-0.7-0.4-1.1-0.7
                c-0.4-0.3-0.6-1-1.1-1.2c-0.2-0.1-0.5-0.1-0.7-0.2c-0.1-0.1-0.2-0.3-0.3-0.5c-0.1-0.2-0.2-0.3-0.4-0.3c-0.1,0-0.1,0.1-0.2,0.1
                c-0.4,0.4-0.4,1-0.9,1.3c-0.1,0.1-0.3,0.1-0.5,0.2c-0.4,0.2-0.8,0.6-0.9,1.1c-0.3-0.2-0.4-0.7-0.3-1.1c0.1-0.4,0.4-0.7,0.6-1.1
                c0.2-0.4,0.3-0.8,0.5-1.1c0.2-0.4,0.4-0.7,0.8-0.8c0.3-0.1,0.7,0,1-0.1c0.3,0,0.6-0.2,0.8-0.3c0.8-0.3,1.8-0.1,2.4,0.5
                c0.2,0.2,0.4,0.4,0.6,0.6c0.5,0.5,0.9,1,1.4,1.5c0.2,0.2,0.4,0.5,0.5,0.8c0.2,0.5-0.1,1.1-0.4,1.6c-0.1,0.2-0.3,0.5-0.5,0.6
                C235.7,117,235,117.1,234.8,116.5z"
                />
                <path
                  id="XMLID_10404_"
                  className="st85"
                  d="M234.9,116.7c0-0.1,0.1-0.2,0.2-0.3c0.2-0.1,0.6-0.3,0.9-0.1c0.5,0.3-0.2,1.5-1.1,1.1
                C235,117.5,234.7,117.3,234.9,116.7z"
                />
              </g>
            </g>
            <g id="XMLID_10191_">
              <path
                id="XMLID_10400_"
                className="st34"
                d="M284.4,111.6h-34.6c-0.3,0-0.5-0.2-0.5-0.5v-0.5c0-0.3,0.2-0.5,0.5-0.5h34.6
              c0.3,0,0.5,0.2,0.5,0.5v0.5C284.9,111.4,284.7,111.6,284.4,111.6z"
              />
              <path
                id="XMLID_10399_"
                className="st34"
                d="M284.4,119.6h-34.6c-0.3,0-0.5-0.2-0.5-0.5v-0.5c0-0.3,0.2-0.5,0.5-0.5h34.6
              c0.3,0,0.5,0.2,0.5,0.5v0.5C284.9,119.4,284.7,119.6,284.4,119.6z"
              />
              <path
                id="XMLID_10197_"
                className="st34"
                d="M276.3,115.3h-26.4c-0.3,0-0.5-0.2-0.5-0.5v-0.5c0-0.3,0.2-0.5,0.5-0.5h26.4
              c0.3,0,0.5,0.2,0.5,0.5v0.5C276.7,115.1,276.5,115.3,276.3,115.3z"
              />
              <path
                id="XMLID_10196_"
                className="st34"
                d="M296.9,115.3h-18.2c-0.3,0-0.5-0.2-0.5-0.5v-0.5c0-0.3,0.2-0.5,0.5-0.5h18.2
              c0.3,0,0.5,0.2,0.5,0.5v0.5C297.4,115.1,297.2,115.3,296.9,115.3z"
              />
              <path
                id="XMLID_10195_"
                className="st34"
                d="M260.1,125.7c0-0.9-0.7-1.7-1.7-1.7c-0.9,0-1.7,0.7-1.7,1.7c0,0.9,0.7,1.7,1.7,1.7
              C259.4,127.3,260.1,126.6,260.1,125.7z"
              />
              <path
                id="XMLID_10194_"
                className="st34"
                d="M268.8,127.3c0.9,0,1.7-0.7,1.7-1.7c0-0.9-0.7-1.7-1.7-1.7c-0.9,0-1.7,0.7-1.7,1.7
              C267.1,126.6,267.9,127.3,268.8,127.3z"
              />
              <path
                id="XMLID_10193_"
                className="st34"
                d="M278.3,127.3c0.9,0,1.7-0.7,1.7-1.7c0-0.9-0.7-1.7-1.7-1.7c-0.9,0-1.7,0.7-1.7,1.7
              C276.6,126.6,277.4,127.3,278.3,127.3z"
              />
            </g>
          </g>
          <g id="XMLID_9844_">
            <g id="XMLID_9851_">
              <path
                id="XMLID_10189_"
                fill={props.color1 ? props.color1 : '#FF4137'}
                className="st12"
                d="M380.2,50.7H298c-4,0-7.3,3.3-7.3,7.3v36.3c0,4,3.3,7.3,7.3,7.3h8v14.1l8.7-14.1h65.4
              c4,0,7.3-3.3,7.3-7.3V58C387.5,54,384.3,50.7,380.2,50.7z"
              />
              <circle id="XMLID_10188_" className="st6" cx="306.6" cy="70.9" r="8.4" />
              <path
                id="XMLID_9991_"
                className="st6"
                d="M349.4,64.7h-24.9c-0.3,0-0.6-0.3-0.6-0.6v-1c0-0.3,0.3-0.6,0.6-0.6h24.9
              c0.3,0,0.6,0.3,0.6,0.6v1C350,64.5,349.7,64.7,349.4,64.7z"
              />
              <path
                id="XMLID_9887_"
                className="st6"
                d="M379.6,72.5h-55.1c-0.3,0-0.6-0.3-0.6-0.6v-1c0-0.3,0.3-0.6,0.6-0.6h55.1
              c0.3,0,0.6,0.3,0.6,0.6v1C380.2,72.3,379.9,72.5,379.6,72.5z"
              />
              <path
                id="XMLID_9855_"
                className="st6"
                d="M366.7,78.4h-42.2c-0.3,0-0.6-0.3-0.6-0.6v-1c0-0.3,0.3-0.6,0.6-0.6h42.2
              c0.3,0,0.6,0.3,0.6,0.6v1C367.3,78.1,367,78.4,366.7,78.4z"
              />
              <path
                id="XMLID_9854_"
                className="st6"
                d="M316.8,92.7c0-1.5-1.2-2.6-2.6-2.6c-1.5,0-2.6,1.2-2.6,2.6c0,1.5,1.2,2.6,2.6,2.6
              C315.6,95.3,316.8,94.1,316.8,92.7z"
              />
              <path
                id="XMLID_9853_"
                className="st6"
                d="M330.5,95.3c1.5,0,2.6-1.2,2.6-2.6c0-1.5-1.2-2.6-2.6-2.6c-1.5,0-2.6,1.2-2.6,2.6
              C327.9,94.1,329,95.3,330.5,95.3z"
              />
              <path
                id="XMLID_9852_"
                className="st6"
                d="M345.6,95.3c1.5,0,2.6-1.2,2.6-2.6c0-1.5-1.2-2.6-2.6-2.6c-1.5,0-2.6,1.2-2.6,2.6
              C342.9,94.1,344.1,95.3,345.6,95.3z"
              />
            </g>
            <path
              id="XMLID_9850_"
              className="st34"
              d="M307.4,72.5c-0.8-1-1.4-2.1-1.9-3c-0.2-0.4-0.1-0.9,0.3-1.1l0.6-0.4
            c0.3-0.2,0.4-0.7,0.2-1l-1-1.5c-0.2-0.3-0.7-0.4-1-0.2l-1.5,1c-0.7,0.4-0.9,1.3-0.6,2c0.8,1.8,2.5,5.1,4.9,7.5
            c0.6,0.5,1.4,0.6,2,0.2l1.3-0.9c0.5-0.3,0.6-0.9,0.3-1.4l-0.7-1c-0.3-0.5-0.9-0.6-1.4-0.3l-0.4,0.3
            C308.2,73,307.7,72.9,307.4,72.5z"
            />
          </g>
        </g>
      </g>
      <g id="Calque_7"></g>
    </svg>
  );
}

export default IllustrationContactSvg;
